import React, { useState, useRef, useEffect } from "react";
import { Box, Button, HStack, ScrollView } from "native-base";
import { COLORS } from "../../utils/colors";
import { View } from "react-native";

const ToggleButton = ({
  options = [],
  activeButton = "",
  setActiveButton = () => {},
  boxShawdow = "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
  width = "fit-content",
}) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const boxRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const measureOverflow = () => {
      if (boxRef?.current && contentRef?.current) {
        boxRef?.current?.measure((boxX, boxY, boxWidth, boxHeight) => {
          contentRef?.current?.measure(
            (contentX, contentY, contentWidth, contentHeight) => {
              if (contentWidth > boxWidth) {
                setIsOverflowing(true);
              } else {
                setIsOverflowing(false);
              }
            }
          );
        });
      }
    };
    measureOverflow();

    const boxNode = boxRef?.current;
    boxNode && boxNode.addEventListener("layout", measureOverflow);

    return () => {
      boxNode && boxNode.removeEventListener("layout", measureOverflow);
    };
  }, [options]);

  const handleToggle = (option) => {
    setActiveButton(option);
  };

  return (
    <Box
      bg={COLORS.WHITE_COLOR}
      w={width}
      borderRadius="100px"
      style={{
        boxShadow: boxShawdow,
        width: isOverflowing ? "" : "fit-content",
      }}
      py={1}
      pl={1}
      pr={1}
      ref={boxRef}
    >
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        <HStack space={1} ref={contentRef}>
          {options.map((option) => (
            <Button
              key={option}
              p={1}
              onPress={() => handleToggle(option)}
              borderRadius="100px"
              bg={activeButton === option && COLORS.TOGGLE_ACTIVE_BUTTON_COLOR}
              _hover={{
                backgroundColor:
                  activeButton === option ? COLORS.THEME_COLOR : "transperant",
                _text: {
                  color:
                    activeButton === option
                      ? COLORS.WHITE_COLOR
                      : COLORS.BLACK_COLOR,
                },
              }}
              _focus={{ backgroundColor: COLORS.TOGGLE_ACTIVE_BUTTON_COLOR }}
              _text={{
                color:
                  activeButton === option
                    ? COLORS.TOGGLE_ACTIVE_TEXT_COLOR
                    : COLORS.TOGGLE_INACTIVE_TEXT_COLOR,
                padding: 1,
              }}
              w={"auto"}
            >
              {option}
            </Button>
          ))}
        </HStack>
      </ScrollView>
    </Box>
  );
};

export default ToggleButton;
